import { render, staticRenderFns } from "./ComponentsStoreAlert.vue?vue&type=template&id=3271ed45&scoped=true&"
import script from "./ComponentsStoreAlert.vue?vue&type=script&lang=js&"
export * from "./ComponentsStoreAlert.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsStoreAlert.vue?vue&type=style&index=0&id=3271ed45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271ed45",
  null
  
)

export default component.exports